import { useMemo } from 'react';

import ROUTES from '@/common/routes';
import { useHistory } from '@/modules/core/hooks';

const RESERVED_PAGES = [
  ROUTES.REIMBURSE_ME,
  ROUTES.USE_MY_MONEY,
  ROUTES.REQUEST_BILL_PAY,
  ROUTES.RECEIPT_VAULT,
  ROUTES.BUY_SELL,
  ROUTES.SELF_DIRECTED(' '),
  ROUTES.SELF_DIRECTED_INVEST_MORE(' '),
  ROUTES.SELF_DIRECTED_SWITCH_SELECT(' '),

  ROUTES.SELF_DIRECTED_EMPTY_SWITCH_QUESTIONNAIRE(' '),
  ROUTES.SELF_DIRECTED_EMPTY_SWITCH_SELECT(' '),
  ROUTES.SELF_DIRECTED_EMPTY_SWITCH_ALLOCATION(' '),

  ROUTES.MANAGED_SWITCH_QUESTIONNAIRE(' '),
  ROUTES.MANAGED_SWITCH_FUNDING_AMOUNT(' '),
  ROUTES.MANAGED_SWITCH_ALLOCATION(' '), 

  ROUTES.MANAGED_SWITCH_EMPTY_QUESTIONNAIRE(' '),
  ROUTES.MANAGED_SWITCH_EMPTY_FUNDING_AMOUNT(' '),
  ROUTES.MANAGED_SWITCH_EMPTY_ALLOCATION(' '), 

  ROUTES.SELF_DIRECTED_SWITCH_ALLOCATION(' '),
  ROUTES.MANAGED_SELL_INVESTMENTS(' '),
  ROUTES.SELF_DIRECTED_ALLOCATION(' '),
  ROUTES.SELF_DIRECTED_QUESTIONNAIRE(' '),
  ROUTES.START_INVESTING,
  ROUTES.INVESTMENTS_UPDATE_RISK_PORTFOLIO

];
export const useDefaultContentWrapper = () => {
  const { location } = useHistory();

  return useMemo(() => {
    if (RESERVED_PAGES.find((item) => location.pathname.includes(item.trim()))) {
      return false;
    }
    return true;
  }, [location.pathname]);
};
